import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import SmartBanner from 'react-smartbanner';
import { getAnalyticsUrl } from './analyticsUrl';
import { StyledContentDiv } from './MobileSmartBanner.styles';
import 'react-smartbanner/dist/main.css';
import './MobileSmartBanner.css';

export interface MobileSmartBannerProps {}

const MobileSmartBanner: FC<MobileSmartBannerProps> = () => {
  const { t } = useTranslation('MobileSmartBanner');
  const url = getAnalyticsUrl();

  return (
    <StyledContentDiv id="MobileSmartBanner">
      <SmartBanner
        daysHidden={30}
        daysReminder={1}
        appStoreLanguage="us"
        title={t('title')}
        author={t('author')}
        button={t('buttonLabel')}
        storeText={{
          ios: '',
          android: '',
        }}
        price={{
          ios: '',
          android: '',
        }}
        position="top"
        // force="ios"
        url={url}
        ignoreIosVersion={false}
      />
    </StyledContentDiv>
  );
};

export default MobileSmartBanner;
